import * as React from 'react';
import PersistentIframeController from 'components/persistent-iframe/persistent-iframe-controller';
import DocumentTitle from 'react-document-title';
import { CustomFrontendMenuEntry } from './customFrontendManifest';

interface Props {
    menuEntry: CustomFrontendMenuEntry;
}

const CustomFrontendHost = ({ menuEntry }: Props) => {
    return (
        <>
            <DocumentTitle title={menuEntry.label} />
            <div style={{ height: '100%' }}>
                <PersistentIframeController
                    route={menuEntry.iframeRoute}
                    appName={menuEntry.appId}
                    key={menuEntry.id}
                />
            </div>
        </>
    );
};

export default CustomFrontendHost;
